import { render } from "./RelacionProcesoDato.vue?vue&type=template&id=2752a708"
import script from "./RelacionProcesoDato.vue?vue&type=script&lang=js"
export * from "./RelacionProcesoDato.vue?vue&type=script&lang=js"

import "./RelacionProcesoDato.vue?vue&type=style&index=0&id=2752a708&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__